
// //manually UPDATE THE CART VALUES to add cart notes and ATL - v1 del
// document.addEventListener('DOMContentLoaded', function() {

//   // console.log("Checkout");
//   const checkoutBtn = document.querySelector('button[name="checkout"]');

//   const errorMsg = document.getElementById('authority-error');

//   const radios = document.querySelectorAll('input[name="attributes[Authority to Leave]"]');
  
//   const noteEl = document.getElementById('CartSpecialInstructions');
//   if (noteEl) {
//     if (noteEl.value.trim() === 'Yes' || noteEl.value.trim() === 'No') {
//       noteEl.value = '';
//     }
//   }

//   if (!checkoutBtn) return;

//   // Hide error when a radio is selected
//   radios.forEach(radio => {
//     radio.addEventListener('change', function() {
//       if (this.checked) {
//         errorMsg.style.display = 'none';
//       }
//     });
//   });

//   checkoutBtn.addEventListener('click', function(e) {
//     e.preventDefault();

//     // Find the selected radio
//     const selected = document.querySelector('input[name="attributes[Authority to Leave]"]:checked');
//     console.log("selected", selected);

//     if (!selected) {
//       e.preventDefault();
//       e.stopImmediatePropagation(); // stops other scripts (like apps) from continuing checkout
//       errorMsg.style.display = 'block';
//       errorMsg.scrollIntoView({ behavior: 'smooth', block: 'center' });
//       return;
//     }

//     const authorityValue = selected.value;
//     // console.log("authorityValue", authorityValue);

//     const note = noteEl ? noteEl.value : '';
//     // console.log("note", note);

//     // Update Shopify cart
//     fetch('/cart/update.js', {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify({
//         note: note,
//         attributes: {
//           "Authority to Leave": authorityValue
//         }
//       })
//     })
//     .then(res => res.json())
//     .then(() => {
//       window.location.href = '/checkout';
//     })
//     .catch(err => {
//       console.error('Cart update failed', err);
//       window.location.href = '/checkout'; // fallback
//     });
//   });
// });



// v2
let isUpdatingATL = false;

function toggleCheckoutButtons(disabled) {
    const buttons = document.querySelectorAll('[name="checkout"], .cart__checkout-button');

    buttons.forEach(btn => {
        btn.disabled = disabled;
        btn.style.opacity = disabled ? '0.6' : '1';
        btn.style.pointerEvents = disabled ? 'none' : 'auto';
    });
}

function updateCartATL(value) {
    isUpdatingATL = true;
    toggleCheckoutButtons(true);

    return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            attributes: {
                "Authority to Leave": value
            }
        })
    })
    .then(res => res.json())
    .then(cart => {
        isUpdatingATL = false;
        toggleCheckoutButtons(false);
        // console.log('ATL updated to:', cart.attributes["Authority to Leave"]);
        return cart;
    })
    .catch(err => {
        console.error('Error updating ATL:', err);
        isUpdatingATL = false;
        toggleCheckoutButtons(false);
    });
}

// Prevent checkout while updating
document.addEventListener('click', function(e) {
    const checkoutBtn = e.target.closest('[name="checkout"], .cart__checkout-button');

    if (checkoutBtn && isUpdatingATL) {
        e.preventDefault();
        console.log('Waiting for ATL update...');
    }
});

function initATL() {
    const radios = document.querySelectorAll('input[name="attributes[Authority to Leave]"]');
    if (!radios.length) return;

    // Avoid double-binding
    if (radios[0].dataset.atlBound) return;
    radios.forEach(r => r.dataset.atlBound = "true");

    // Set on load
    const checkedRadio = document.querySelector('input[name="attributes[Authority to Leave]"]:checked');
    if (checkedRadio) {
        // console.log('ATL init:', checkedRadio.value);
        updateCartATL(checkedRadio.value);
    }

    // On change
    radios.forEach(radio => {
        radio.addEventListener('change', function() {
            // console.log('ATL changed:', this.value);
            updateCartATL(this.value);
        });
    });
}

// Watch cart dynamically
const observer = new MutationObserver(() => {
    initATL();
});

observer.observe(document.body, {
    childList: true,
    subtree: true
});

// Also try once on load (for normal cart pages)
document.addEventListener('DOMContentLoaded', initATL);